// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-container form {
  border-top: 5px solid #008000;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.news-container form button {
  border-radius: 0;
}

.news-container form button:hover {
  filter: brightness(1.1);
}

.news-container form .btn-save {
  background-color: #2c3e50;
  color: #fff;
  border: 1px solid #2c3e50;
}

.news-container .newsList .news-image{
  object-fit: cover;
  height: 200px;
}

.popup-box .btn-update {
  background-color: #2c3e50;
  color: #fff;
  border: 1px solid #2c3e50;
}

.popup-box .btn-update:hover{
  filter: brightness(0.9);
}`, "",{"version":3,"sources":["webpack://./src/styles/news.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".news-container form {\r\n  border-top: 5px solid #008000;\r\n  background-color: #fff;\r\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n}\r\n\r\n.news-container form button {\r\n  border-radius: 0;\r\n}\r\n\r\n.news-container form button:hover {\r\n  filter: brightness(1.1);\r\n}\r\n\r\n.news-container form .btn-save {\r\n  background-color: #2c3e50;\r\n  color: #fff;\r\n  border: 1px solid #2c3e50;\r\n}\r\n\r\n.news-container .newsList .news-image{\r\n  object-fit: cover;\r\n  height: 200px;\r\n}\r\n\r\n.popup-box .btn-update {\r\n  background-color: #2c3e50;\r\n  color: #fff;\r\n  border: 1px solid #2c3e50;\r\n}\r\n\r\n.popup-box .btn-update:hover{\r\n  filter: brightness(0.9);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
